import * as React from 'react';
import smoothscroll from 'smoothscroll-polyfill';
import { PrimaryButton } from '@mlc/web-ui-toolkit';
import * as Styled from './styled';
import { NavigateToTopElements } from './NavigateToTopElements';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/pro-regular-svg-icons';

//Can pass in a query selector if the navigate to top button is supposed to stop at a certain position
interface Props {
	footerQuerySelector?: string;
}

interface State {
	isAtTop: boolean;
	isAtFooter: boolean;
	footerHeight: number;
}

const initialState: State = {
	isAtTop: true,
	isAtFooter: false,
	footerHeight: 0,
};

export class NavigateToTopButton extends React.Component<Props, State> {
	constructor(props: any) {
		super(props);
		//enable polyfill for window.scroll with smooth option on all browsers
		smoothscroll.polyfill();
		this.state = initialState;
		this.handleState = this.handleState.bind(this);
	}

	footer = this.props.footerQuerySelector
		? document.querySelector(this.props.footerQuerySelector)
		: null;

	handleState() {
		this.setState({
			isAtTop: window.scrollY == 0,
			isAtFooter: this.footer
				? this.footer.getBoundingClientRect().top <= window.innerHeight
				: false,
			footerHeight: this.footer
				? window.innerHeight - this.footer.getBoundingClientRect().top
				: window.innerHeight,
		});
	}

	UNSAFE_componentWillMount() {
		window.addEventListener('scroll', this.handleState);
		window.addEventListener('click', this.handleState);
		this.handleState();
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.handleState);
		window.addEventListener('click', this.handleState);
	}

	render() {
		if (!this.state.isAtTop) {
			return (
				<Styled.NavToTopContainer
					style={{
						bottom: this.state.isAtFooter ? this.state.footerHeight : '0px',
					}}
				>
					<PrimaryButton
						onClick={() => {
							window.scroll({ top: 0, left: 0, behavior: 'smooth' });
							var scrollTimeout: any;
							addEventListener('scroll', function scrollListener(e) {
								clearTimeout(scrollTimeout);
								scrollTimeout = setTimeout(function() {
									let headers = document.getElementsByTagName('h1');
									if (headers[0]) {
										headers[0].focus();
									}
									removeEventListener('scroll', scrollListener);
								}, 100);
							});
						}}
						data-id={NavigateToTopElements.navigateToTopLink}
						aria-label="Scroll to top of page"
					>
						<FontAwesomeIcon icon={faChevronUp} size="xs" />
					</PrimaryButton>
				</Styled.NavToTopContainer>
			);
		} else {
			return null;
		}
	}
}

export default NavigateToTopButton;
